
const digest = 'b52fa1f0ff1e6ea43e1dd0720b9af20975432e57b851fc62ca6e9d2c70d472f4';
const classes = {"title":"_title_jo7ts_1","groupFiles":"_groupFiles_jo7ts_7","file":"_file_jo7ts_13","checkbox":"_checkbox_jo7ts_21"};
const css = `._title_jo7ts_1 {
  font-size: 14px;
  font-weight: 500;
  margin: 10px 0;
}

._groupFiles_jo7ts_7 {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: 20px;
  padding: 10px 14px 20px 14px;
}
._groupFiles_jo7ts_7 ._file_jo7ts_13 {
  border-radius: 15px;
  width: 100%;
  aspect-ratio: 1/1.2;
  border: 1px solid #EAEDF4;
  padding: 12px;
  position: relative;
}
._groupFiles_jo7ts_7 ._file_jo7ts_13 ._checkbox_jo7ts_21 {
  position: absolute;
  right: 4px;
  top: 4px;
}
._groupFiles_jo7ts_7 ._file_jo7ts_13 img {
  width: 100%;
  max-height: 100%;
  object-fit: cover;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  